module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-interactive-learning-400x284-a943bbfa20ddb9e5cec16db389ffef7e.jpg";